import React from 'react';
import PropTypes from 'prop-types';
import { InputControl, Row, Col } from '@si-armes/dsfr-react';
import { getMessageErreurChampManquant, getPatternHookFormValidation } from 'utils/utils';
import { REGEXP_EMAIL, REGEXP_NOM_PRENOM } from 'constants/contraintes.constants';
import SelectDepartements from 'components/form/referentiel/select/SelectDepartement';

const InformationsUtilisateurNonConnecte = ({ hookForm }) => {
    const { register, formState } = hookForm;

    const validatePrenom = (valuePrenom) => {
        if (!valuePrenom) {
            return getMessageErreurChampManquant('Prénom');
        }
        return null;
    };

    const validateDepartement = (valueDepartement) => {
        if (!valueDepartement) {
            return getMessageErreurChampManquant('Préfecture de rattachement');
        }
        return null;
    };

    return (
        <>
            <Row gutters>
                <Col col={12} lg={6}>
                    <InputControl
                        autocomplete="family-name"
                        label="Nom *"
                        required
                        id="contact-nom"
                        uppercase
                        {...register('nom', {
                            required: getMessageErreurChampManquant('nom'),
                            pattern: getPatternHookFormValidation(REGEXP_NOM_PRENOM, 'nom'),
                        })}
                        state={formState.errors?.nom ? 'error' : null}
                        message={formState.errors?.nom?.message}
                    />
                </Col>
                <Col col={12} lg={6}>
                    <InputControl
                        autocomplete="given-name"
                        label="Prénom *"
                        id="contact-prenom"
                        required
                        uppercase
                        {...register('prenom', {
                            pattern: getPatternHookFormValidation(REGEXP_NOM_PRENOM, 'prenom'),
                            validate: (value) => validatePrenom(value),
                        })}
                        state={formState.errors?.prenom ? 'error' : null}
                        message={formState.errors?.prenom?.message}
                    />
                </Col>
            </Row>
            <Row gutters>
                <Col col={12} lg={6}>
                    <InputControl
                        autocomplete="email"
                        label="E-mail *"
                        type="text"
                        id="contact-email"
                        hintText="Exemple: ministere.interieur@exemple.com"
                        required
                        {...register('email', {
                            required: getMessageErreurChampManquant('E-mail'),
                            pattern: {
                                value: REGEXP_EMAIL,
                                message:
                                    "Le format de l'adresse mail n'est pas valide ( Exemple: ministere.interieur@exemple.com )",
                            },
                        })}
                        state={formState.errors?.email ? 'error' : null}
                        message={formState.errors?.email?.message}
                    />
                </Col>
            </Row>
            <Row gutters>
                <Col col={12} lg={6}>
                    <SelectDepartements
                        name="prefecture"
                        id="contact-prefecture"
                        label="Préfecture de rattachement *"
                        texteAide="Préfecture liée au département de la résidence principale du détenteur"
                        placeholder="-- Choisir une option --"
                        register={register('prefecture', {
                            validate: (value) => validateDepartement(value),
                        })}
                        required
                    />
                </Col>
            </Row>
        </>
    );
};

InformationsUtilisateurNonConnecte.propTypes = {
    hookForm: PropTypes.func.isRequired,
};

export default InformationsUtilisateurNonConnecte;
